export const bData = [
  {
    "title": "Birthday Decor 1",
    "description": "Birthday Baloon ring Decoration",
    "price": 9999,
    "rating": 4.5,
    "image": "https://www.partyone.in/suploads/2024/Jun/26/38857/1719365590IMG_E7413.webp"
  },
  {
    "title": "Birthday Decor 2",
    "description": "Aeroplane Theame Birthday Decoration",
    "price": 8999,
    "rating": 4,
    "image": "https://www.partyone.in/suploads/2025/Feb/22/39337/1740209948image-53.webp"
  },
  {
    "title": "Birthday Decor 3",
    "description": "Amazing fozen theame Birthday Decoration",
    "price": 5300,
    "rating": 4.2,
    "image": "https://www.partyone.in/suploads/2024/Jul/02/38905/1719917140IMG_8201.webp"
  },
  {
    "title": "Birthday Decor 4",
    "description": "chess theame bday decor",
    "price": 9999,
    "rating": 4.2,
    "image": "https://www.partyone.in/suploads/2024/Mar/26/38747/1711449530Chess_Decor2.webp"
  },
  {
    "title": "Birthday Decor 5",
    "description": "Teddy Birthday Decoration.",
    "price": 14999,
    "rating": 4.6,
    "image": "https://www.partyone.in/suploads/2024/Jul/01/38893/1719805441IMG_E7724.webp"
  },
  {
    "title": "Birthday Decor 6",
    "description": "Pink swan theame birthday decoration",
    "price": 2700,
    "rating": 4.6,
    "image": "https://www.partyone.in/suploads/2024/Sep/16/38763/1726462051WhatsApp-Image-2024-06-04-at-3.47.webp"
  },
  {
    "title": "Birthday Decor 7",
    "description": "Beautiful Flamingo Birthday ring Decoration",
    "price": 8999,
    "rating": 5,
    "image": "https://www.partyone.in/suploads/2024/Sep/18/38996/1726639397WhatsApp-Image-2024-07-24-at-5.29.webp"
  },
  {
    "title": "Birthday Decor 8",
    "description": "Black and white Birthday decor",
    "price": 7900,
    "rating": 4.9,
    "image": "https://www.partyone.in/suploads/2024/Mar/26/38749/1711449601Black_Decor.webp"
  },
  {
    "title": "Birthday Decor 9",
    "description": "Baby shark birthday theame",
    "price": 5900,
    "rating": 4.7,
    "image": "https://www.partyone.in/suploads/2024/Jul/01/38892/1719802092IMG_E7693.webp"
  },
  {
    "title": "Birthday Decor 10",
    "description": "FootBall Birthday Decoration",
    "price": 6600,
    "rating": 4.1,
    "image": "https://www.partyone.in/suploads/2024/Mar/27/38777/1711540787FootBall_Theme1.webp"
  },
  {
    "title": "Birthday Decor 11",
    "description": "Green colourtheame Birthday Decor",
    "price": 6999,
    "rating": 4,
    "image": "https://www.partyone.in/suploads/2024/Mar/19/38706/1710846106birthdaydecor_green%20Theme2.webp"
  },
  {
    "title": "Birthday Decor 12",
    "description": "Spiderman birthday theame decor",
    "price": 8000,
    "rating": 4.8,
    "image": "https://www.partyone.in/suploads/2024/Mar/21/38724/1711015238half%20-arch_spiderman.webp"
  },
  {
    "title": "Birthday Decor 13",
    "description": "Cocomelon Birthday Decoration",
    "price": 22999,
    "rating": 4.6,
    "image": "https://www.partyone.in/suploads/2024/Jul/01/38894/1719805927IMG_E7805.webp"
  },
  {
    "title": "Birthday Decor 14",
    "description": "Cocomelon decoration theame",
    "price": 6499,
    "rating": 5,
    "image": "https://www.partyone.in/suploads/2024/Jun/26/38859/1719366823IMG_E4677.webp"
  },
  {
    "title": "Birthday Decor 15",
    "description": "Cocomelon Birthday Decor",
    "price": 5400,
    "rating": 4.3,
    "image": "https://www.partyone.in/suploads/2024/Jul/23/38924/1721707326HIP00705.webp"
  },
  {
    "title": "Birthday Decor 16",
    "description": "baby house minnie decoration theame",
    "price": 16999,
    "rating": 5,
    "image": "https://www.partyone.in/suploads/2024/Jun/30/38887/1719755210IMG_E7513.webp"
  },
  {
    "title": "Birthday Decor 17",
    "description": "candy theame baloon arch decoration",
    "price": 2500,
    "rating": 4.5,
    "image": "https://www.partyone.in/suploads/2024/Jul/01/38893/1719805441IMG_E7724.webp"
  },
  {
    "title": "Birthday Decor 18",
    "description": "Hulk theame Birthday decoration",
    "price": 5400,
    "rating": 4.3,
    "image": "https://www.partyone.in/suploads/2024/Jul/04/38938/1720077553IMG_3986.webp"
  },
 {
    "title": "Birthday Decor 19",
    "description": "Amazing fozen theame Birthday Decoration",
    "price": 5300,
    "rating": 4.2,
    "image": "https://www.partyone.in/suploads/2024/Jul/02/38905/1719917140IMG_8201.webp"
  },
  {
    "title": "Birthday Decor 20",
    "description": "Spiderman birthday theame decor",
    "price": 8000,
    "rating": 4.8,
    "image": "https://www.partyone.in/suploads/2024/Mar/21/38724/1711015238half%20-arch_spiderman.webp"
  }
];